import React from "react";
import { EmailIcon } from "react-share";
import { EmailShareButton } from "react-share";
import { FacebookShareButton } from "react-share";
import { LinkedinShareButton } from "react-share";
import { LinkedinIcon } from "react-share";
import { TelegramIcon } from "react-share";
import { TelegramShareButton } from "react-share";
// import { TwitterIcon } from "react-share";
import { TwitterShareButton } from "react-share";
import { WhatsappIcon } from "react-share";
import { WhatsappShareButton } from "react-share";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import Row from "reactstrap/lib/Row";
import AdComponent from "../leaflet/Adsense";
import { serverResponse } from "../../util/fakeServer";
import { gaEventLabel } from "../../settings/gaConfig";
import { FacebookIcon } from "react-share";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { NotificationManager } from "react-notifications";
import { defaultLanguage, sendAnalyticsEvent } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import  CustomTwitterIcon  from "../../assets/icons/twitter.icon";


const link = serverResponse.config.shareFlyerURL;
const title = serverResponse.config.shareFlyerTitle;

// Le icone stanno su tile neutre e portano il colore ufficiale del servizio:
// e' il colore a farle riconoscere a colpo d'occhio, la tile resta grigia per
// non litigare con il colore primario del cliente.
const BRAND = {
  facebook: "#1877F2",
  whatsapp: "#25D366",
  telegram: "#229ED9",
  email: "#5F6368",
  linkedin: "#0A66C2",
  x: "#000000",
};

const ICON_SIZE = 50;
const flatIcon = { fill: "transparent" };

// Dentro la webview dell'app la condivisione WhatsApp passa dal ponte JS.
// Prima le due varianti convivevano nel DOM alternandosi con display
// inline/none: ora se ne renderizza una sola, cosi' il layout delle tile non
// dipende da uno stile inline.
const isNativeApp = window.ReactNativeWebView !== undefined;

const ShareModal = ({ open, setOpen }) => {
  const toggle = () => {
    setOpen(false);
  };

  const copyToClip = () => {
    navigator.clipboard
      .writeText(serverResponse.config.shareFlyerURL)
      .then(() =>
        NotificationManager.success(
          "Elemento Copiato",
          "Link Copiato con successo ",
          1000
        )
      )
      .catch((err) => {
        NotificationManager.error(
          "Errore nella copia",
          "Link Non Copiato",
          1000
        );
      });
  };

  const openReactNativeShare = () => {
    const str = title + "    " + link;
    const obj = { action: "whatsapp", value: str };
    window.ReactNativeWebView &&
      window.ReactNativeWebView.postMessage(JSON.stringify(obj));
  };

  return (
    <div>
      <Modal
        className="modal_share_custom"
        centered
        isOpen={open}
        toggle={toggle}
      >
        <ModalHeader toggle={toggle}>
          {language[defaultLanguage].condividi_con}
        </ModalHeader>
        <ModalBody>
          {/* Griglia auto-fit: le tile vanno a capo da sole al restringersi
              della modale, senza breakpoint dedicati. */}
          <div className="custom-share-container share-grid">
            <FacebookShareButton
              className="facebookShareButton shareIcon share-tile"
              resetButtonStyle={false}
              url={link}
              beforeOnClick={() => {
                sendAnalyticsEvent(gaEventLabel.share_leaflet_facebook);
              }}
            >
              <span className="share-tile__icon">
                <FacebookIcon
                  size={ICON_SIZE}
                  bgStyle={flatIcon}
                  iconFillColor={BRAND.facebook}
                />
              </span>
              <span className="share-tile__label">Facebook</span>
            </FacebookShareButton>

            {isNativeApp ? (
              <span
                className="share-tile"
                onClick={() => openReactNativeShare()}
              >
                <span className="share-tile__icon">
                  <WhatsappIcon
                    size={ICON_SIZE}
                    bgStyle={flatIcon}
                    iconFillColor={BRAND.whatsapp}
                  />
                </span>
                <span className="share-tile__label">WhatsApp</span>
              </span>
            ) : (
              <WhatsappShareButton
                className="whatsappShareIcon shareIcon share-tile"
                resetButtonStyle={false}
                title={title}
                url={link}
                beforeOnClick={() => {
                  sendAnalyticsEvent(gaEventLabel.share_leaflet_whatsapp);
                }}
              >
                <span className="share-tile__icon">
                  <WhatsappIcon
                    size={ICON_SIZE}
                    bgStyle={flatIcon}
                    iconFillColor={BRAND.whatsapp}
                  />
                </span>
                <span className="share-tile__label">WhatsApp</span>
              </WhatsappShareButton>
            )}

            <TelegramShareButton
              className="telegramShareIcon shareIcon share-tile"
              resetButtonStyle={false}
              title={title}
              url={link}
              beforeOnClick={() => {
                sendAnalyticsEvent(gaEventLabel.share_leaflet_telegram);
              }}
            >
              <span className="share-tile__icon">
                <TelegramIcon
                  size={ICON_SIZE}
                  bgStyle={flatIcon}
                  iconFillColor={BRAND.telegram}
                />
              </span>
              <span className="share-tile__label">Telegram</span>
            </TelegramShareButton>

            <EmailShareButton
              className="emailShareIcon shareIcon share-tile"
              resetButtonStyle={false}
              url={link}
              subject={title}
              openWindow={false}
              beforeOnClick={() => {
                sendAnalyticsEvent(gaEventLabel.share_leaflet_mail);
              }}
            >
              <span className="share-tile__icon">
                <EmailIcon
                  size={ICON_SIZE}
                  bgStyle={flatIcon}
                  iconFillColor={BRAND.email}
                />
              </span>
              <span className="share-tile__label">Email</span>
            </EmailShareButton>

            <LinkedinShareButton
              className="linkedinShareIcon shareIcon share-tile"
              resetButtonStyle={false}
              title={title}
              url={link}
              beforeOnClick={() => {
                sendAnalyticsEvent(gaEventLabel.share_leaflet_telegram);
              }}
            >
              <span className="share-tile__icon">
                <LinkedinIcon
                  size={ICON_SIZE}
                  bgStyle={flatIcon}
                  iconFillColor={BRAND.linkedin}
                />
              </span>
              <span className="share-tile__label">LinkedIn</span>
            </LinkedinShareButton>

            <TwitterShareButton
              className="twitterShareIcon shareIcon share-tile"
              resetButtonStyle={false}
              title={title}
              url={link}
              beforeOnClick={() => {
                sendAnalyticsEvent(gaEventLabel.share_leaflet_twitter);
              }}
            >
              <span className="share-tile__icon">
                <CustomTwitterIcon
                  size={ICON_SIZE}
                  bgStyle={flatIcon}
                  iconFillColor={BRAND.x}
                />
              </span>
              <span className="share-tile__label">X</span>
            </TwitterShareButton>
          </div>

          {/* Copia link: era un quadratino nero in mezzo ai social, quindi
              indistinguibile da una condivisione. Ora e' una riga a se', con
              il link in chiaro e un bottone nello stile del progetto. */}
          <div className="share-copy">
            <input
              className="share-copy__link"
              type="text"
              readOnly
              value={link}
              onFocus={(e) => e.target.select()}
              aria-label={language[defaultLanguage].copia_link_volantino}
            />
            <button
              type="button"
              className="share-copy__btn copyButtonVolantino"
              onClick={copyToClip}
              title={language[defaultLanguage].copia_link_volantino}
            >
              <FontAwesomeIcon icon={faCopy} />
              <span>{language[defaultLanguage].copia}</span>
            </button>
          </div>
        </ModalBody>
        {serverResponse.config.adsense && (
          <ModalFooter>
            <AdComponent />
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};

export default ShareModal;
